 
import { Close } from "@mui/icons-material";
import { useEffect, useState } from "react";
import containerModal from "../../../../../assets/styles/components/containerModal.module.css";
import modal from "../../../../../assets/styles/components/modal.module.css";
import Button from "../../../../../components/Button/Button";

import styles from "./PaymentTypeModal.module.css";

interface PaymentOption {
  label: string;
  value: string;
}

const PaymentModal = ({
  onClickModal,
  onPaymentSelected,
  allowSkip = false,
}: {
  onClickModal?: () => void;
  onPaymentSelected?: (paymentMethod: string) => void;
  allowSkip?: boolean;
}) => {
  const [, setSelectedPayment] = useState<string>("");

  const getOptions = (): PaymentOption[] => {
    const options: PaymentOption[] = [
      { label: "Cartão de Crédito", value: "Cartão de crédito" },
      { label: "Cartão de Débito", value: "Cartão de débito" },
      { label: "Vale Alimentação", value: "Vale alimentação" },
      { label: "Vale Refeição", value: "Vale refeição" },
      { label: "Pix", value: "Pix" },
      { label: "Dinheiro", value: "Dinheiro" },
    ];

    if (!allowSkip) {
      options.push({ label: "Desconto", value: "Desconto" });
    }

    options.push({ label: "Mensalista", value: "Mensalista" });

    if (allowSkip) {
      options.push({ label: "Sem tipo definido", value: "Sem definição" });
    }

    return options;
  };

  const currentOptions = getOptions();

  const handlePaymentSelection = (paymentMethod: string) => {
    setSelectedPayment(paymentMethod);
    onPaymentSelected?.(paymentMethod);
  };

  const handleCancel = () => {
    onClickModal?.();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleCancel();
      return;
    }

    const keyNumber = parseInt(e.key, 10);

    if (!isNaN(keyNumber) && keyNumber > 0 && keyNumber <= currentOptions.length) {
      const selectedOption = currentOptions[keyNumber - 1];
      handlePaymentSelection(selectedOption.value);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [allowSkip]);

  return (
    <form className={modal.containerModal}>
      <div
        className={`${containerModal.containerModal} ${styles.paymentModal}`}>
        <div className={styles.paymentTitle}>
          {allowSkip ? "Tipo de pagamento" : "Pagamento"}
        </div>
        <div className={containerModal.close}>
          <Button
            variant="contain"
            typeStyle={["small", "cancel"]}
            onClick={() => onClickModal?.()}
          >
            <Close />
          </Button>
        </div>

        <div className={styles.paymentOptions}>
          {currentOptions.map((option, index) => (
            <div
              key={option.value}
              className={styles.paymentButton}
              onClick={() => handlePaymentSelection(option.value)}>
              {index + 1} - {option.label}
            </div>
          ))}

          <div
            className={styles.paymentButton}
            onClick={() => onClickModal?.()}>
            Esc - Cancelar
          </div>
        </div>
      </div>
    </form>
  );
};

export default PaymentModal;